import { render, staticRenderFns } from "./AdministrativePosition.vue?vue&type=template&id=4b83c43a&scoped=true"
import script from "./AdministrativePosition.vue?vue&type=script&lang=js"
export * from "./AdministrativePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83c43a",
  null
  
)

export default component.exports